import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_Popconfirm = _resolveComponent("Popconfirm")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["skill-item", {selected: $props.selected, pointer: !$props.selected}]),
    onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('edit')))
  }, [
    _createVNode(_component_Icon, {
      icon: "scroll-text",
      class: "skill-icon",
      size: "2rem",
      stroke: "var(--gray-700)",
      "stroke-width": "1"
    }),
    _createVNode(_component_Ellipsis, { class: "text" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($props.skill.command), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IconAsButton, {
        icon: "edit-03",
        color: "--gray-600",
        tooltip: "Edit skill"
      }),
      _createVNode(_component_Popconfirm, {
        width: "max-content",
        "confirm-button-text": "Yes",
        "cancel-button-text": "No",
        title: "Are you sure you want to delete this skill?",
        onConfirm: _cache[1] || (_cache[1] = $event => (_ctx.$emit('delete')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconAsButton, {
            icon: "trash-04",
            color: "--gray-600",
            tooltip: "Delete skill",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 2 /* CLASS */))
}